import { render } from "./IoTRules.vue?vue&type=template&id=35c5d9e4"
import script from "./IoTRules.vue?vue&type=script&lang=js"
export * from "./IoTRules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__